<template>
  <div class="user-situation-container">
    <userDetail :userDetail="userDetailObj"/>
    <remarks :userDetail="userDetailObj"/>
    <orderDetail :userDetail="userDetailObj"/>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect } from 'vue';
import userDetail from './components/user-detail.vue';
import remarks from './components/remarks.vue';
import orderDetail from './components/orderDetail.vue';


const props = defineProps<{
  userDetail: any
}>()

const userDetailObj = ref({})
watchEffect(()=>{
  userDetailObj.value = props.userDetail
})
</script>

<style scoped lang="scss">
.user-situation-container{
  overflow: hidden;
  padding-left: 20px;
  overflow-y: scroll;
}
</style>
